var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "puredata-graph" }, [
    _c("figure", { ref: "figure" }, [
      _c("canvas", { ref: "canvas", attrs: { id: _vm.chartId } })
    ]),
    _vm._v(" "),
    _vm.show_legend
      ? _c("div", { staticClass: "legend" }, [
          _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm._f("trans")("feelgrid:puredata.legend.device"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm._f("trans")("feelgrid:puredata.legend.average"))
                  )
                ]),
                _vm._v(" "),
                _vm.interval === "point"
                  ? _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("feelgrid:puredata.legend.latest")
                        )
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.graph.devices, function(device, device_id) {
                return _c(
                  "tr",
                  {
                    class: { highlight: _vm.highlight === device_id },
                    style: {
                      backgroundColor: "rgba(" + _vm.color[device_id] + ", 0.5)"
                    },
                    on: {
                      mouseenter: function($event) {
                        _vm.set_hl(device_id)
                      },
                      click: function($event) {
                        _vm.fix_hl(device_id)
                      },
                      mouseleave: function($event) {
                        _vm.reset_hl(device_id)
                      }
                    }
                  },
                  [
                    _c("td", [
                      _c("i", {
                        style: {
                          backgroundColor:
                            "rgba(" + _vm.color[device_id] + ", 0.5)"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm._f("text")(device.name)))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "val" }, [
                      _vm._v(_vm._s(_vm.average[device_id]))
                    ]),
                    _vm._v(" "),
                    _vm.interval === "point"
                      ? _c("td", { staticClass: "val" }, [
                          _vm._v(_vm._s(_vm.latest[device_id]))
                        ])
                      : _vm._e()
                  ]
                )
              })
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93879cbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93879cbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/feelgrid/assets/Graph.vue
// module id = null
// module chunks = 